export default "__VITE_ASSET__ZG$MwRFe__"